import Swiper from "swiper";
import "swiper/css";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const eventSlider = document.querySelector(".event-slider");

  new Swiper(eventSlider, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
  });

  const tourSlider = document.querySelector(".tour-list-slider");

  new Swiper(tourSlider, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      992: {
        slidesPerView: 2.1,
      },
      1280: {
        spaceBetween:30,
        slidesPerView: 3.8
      },
    },
  });

  const gallerySlider = document.querySelectorAll(".js-gallery-slider");

  gallerySlider.forEach((elem, index) => {
    gsap.set(elem, {
      x: index % 2 === 0 ? -elem.offsetWidth / 2 : null,
    });
    gsap
      .timeline({
        scrollTrigger: {
          trigger: elem,
          scrub: 4,
        },
      })
      .to(elem, {
        duration: 3,
        x: index % 2 === 0 ? 0 : -elem.offsetWidth,
      });
  });
});
